import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { HttpClient } from '@angular/common/http';
import { SiteContentInterface } from 'src/app/interfaces/sitecontent-interface';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class SiteContentService {

  public siteContent: any;

  constructor(
    private config: ConfigService,
    private http: HttpClient
  ) {
    this.siteContent = new Map();
  }

  public async loadConfig(pageName: string): Promise<SiteContentInterface> {
    if (!pageName) {
      throw new Error('loadConfig called with undefined/null pageName');
    }

    if (this.siteContent.has(pageName)) {
      return this.siteContent.get(pageName)!;
    }

    const fileUrl = this.getCDNAssetPath("site_content/" + pageName) +
      '.config?v=' + new Date().getTime();

    try {
      const response = await firstValueFrom(
        this.http.get<SiteContentInterface>(fileUrl)
      );
      if (response) {
        this.siteContent.set(pageName, response);
        return response;
      }
    } catch (err) {
      console.warn('Site content not loading from CDN for', pageName);

      const localPath = "/assets/site_content/" + pageName + '.config';
      const res = await firstValueFrom(this.http.get<SiteContentInterface>(localPath));
      if (res) {
        this.siteContent.set(pageName, res);
        return res;
      }
    }

    throw new Error(`Failed to load site content: ${pageName}`);
  }

  private getCDNAssetPath(path): string {
    const cdnBaseURL = this.config.getConfig()?.CDN_BASEURL;
    if (undefined !== path) {
      if (undefined !== typeof cdnBaseURL) {
        return cdnBaseURL + "/assets/" + path;
      }
      return "";
    }
  }
}